export const windowReservationDescription = (transactionDate: string): string =>
	`This fund has limited availability. Reserve a spot in the upcoming ${transactionDate} investment window today to ensure your access.`;
